'use client';

import ThemeLayout from '@/layouts/ThemeLayout';
import { useTranslations } from 'next-intl';
import Logo from '../Logo';
import Box from '../ui/Box';
import Btn from '../ui/Btn';
import Container from '../ui/Container';
import Flex from '../ui/Flex';
import Grid from '../ui/Grid';
import NextAnchor from '../ui/NextAnchor';
import Txt from '../ui/Txt';

export type ErrorViewProps = {
  reset?: () => void;
};

export default function ErrorView({ reset }: ErrorViewProps) {
  const t = useTranslations('error');

  return (
    <ThemeLayout colorTheme="dark">
      <Box as="header">
        <Container cx={{ pY: 'lg' }}>
          <NextAnchor href="/" aria-label={t('home')} style={{ color: 'inherit' }}>
            <Logo />
          </NextAnchor>
        </Container>
      </Box>
      <Box as="main" role="main">
        <Container>
          <Grid cx={{ rowGap: 'xl', pY: '5xl' }}>
            <Grid.Col offsetMd={2} md={8}>
              <Txt as="h1" variant="h1" cx={{ mB: 'none' }}>
                {t('title')}
              </Txt>
            </Grid.Col>
            <Grid.Col offsetMd={2} md={8}>
              <Txt as="p" variant="h4">
                {t('summary')}
              </Txt>
              <Flex direction="row" wrap cx={{ columnGap: 'md', rowGap: 'md', mT: 'xl' }}>
                {reset && (
                  <Btn variant="filled" color="accent" onClick={reset}>
                    {t('retry')}
                  </Btn>
                )}
                <Btn variant="filled" color="accent" href="/">
                  {t('home')}
                </Btn>
              </Flex>
            </Grid.Col>
          </Grid>
        </Container>
      </Box>
    </ThemeLayout>
  );
}
